export enum IdentityProviderField {
  ID = 'ID',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  FULL_NAME = 'FULL_NAME',
  LANGUAGE = 'LANGUAGE',
  ADDITIONAL_PHONE = 'ADDITIONAL_PHONE',
  SETTLEMENT = 'SETTLEMENT',
  GENDER = 'GENDER',
  BIRTH_DATE = 'BIRTH_DATE',
  IS_PRM = 'IS_PRM',
}
